export const nav = {
  ariaLabel: "Principal",
  sectionMe: "Yo",
  sectionSettings: "Ajustes",
  home: "Inicio",
  certificates: "Certificados",
  policies: "Políticas",
  people: "Personas",
  activity: "Actividad",
  myCertificates: "Mis certificados",
  myActivity: "Mi actividad",
  organization: "Organización",
  openMenu: "Abrir menú",
  organizationSwitcher: "Cambiar de organización",
  userMenu: "Menú de usuario",
  language: "Idioma",
  platform: "Plataforma",
  platformAdmin: "Administrador de plataforma",
  logout: "Cerrar sesión",
};
